/** Dashboard path for an authenticated user (vendors vs department). */
export function homePathForUser(user) {
  if (!user) return '/';
  if (user.role === 'vendor') return '/vendor/dashboard';
  return '/admin/dashboard';
}
